export const TOFU_CLUSTER_PRODUCT_HINTS = {
  houseplants: 'Super Soil + Plant Super Boost',
  vegetable_garden: 'Crab, Kelp & Amino Acids + Super Soil',
  lawn: 'Plant Super Boost + Crab, Kelp & Amino Acids',
  flowers: 'Crab, Kelp & Amino Acids + Plant Super Boost',
  fruit_trees: 'Crab, Kelp & Amino Acids + Plant Super Boost',
  ornamentals: 'Super Soil + Plant Super Boost',
  specialty_collector: 'Super Soil + Plant Super Boost',
  herbs: 'Super Soil + Crab, Kelp & Amino Acids',
  soil_science: 'All three pillars',
  pests: 'Diatomaceous Earth + Sulfur + Castile Soap',
} as const;

export type TofuClusterKey = keyof typeof TOFU_CLUSTER_PRODUCT_HINTS;

// Maps TOFU group display names to backend cluster keys for product/link routing.
const GROUP_NAME_TO_CLUSTER: Array<{ match: RegExp; key: TofuClusterKey }> = [
  { match: /houseplant/i, key: 'houseplants' },
  { match: /vegetable/i, key: 'vegetable_garden' },
  { match: /^lawn/i, key: 'lawn' },
  { match: /flower/i, key: 'flowers' },
  { match: /fruit tree|berr/i, key: 'fruit_trees' },
  { match: /ornamental/i, key: 'ornamentals' },
  { match: /specialty|collector/i, key: 'specialty_collector' },
  { match: /herb/i, key: 'herbs' },
  { match: /soil science|villain/i, key: 'soil_science' },
  { match: /pest/i, key: 'pests' },
];

export function resolveTofuClusterKey(groupName: string): TofuClusterKey | undefined {
  for (const entry of GROUP_NAME_TO_CLUSTER) {
    if (entry.match.test(groupName)) {
      return entry.key;
    }
  }

  // Why this matters: unknown TOFU groups should skip routing instead of linking to the wrong cluster.
  console.warn(`[TOFU] No cluster key for group: "${groupName}"`);
  return undefined;
}
